import { isArray } from "chart.js/helpers"

const orderDataTableColumns = (unorderedOptionColumns, orderColumns) => {
	if(!orderColumns || !orderColumns.length || !isArray(orderColumns)) {
		return unorderedOptionColumns
	}
	let ordered = []
	orderColumns.forEach(colId => {
		const col = unorderedOptionColumns.find(f => f.id === colId)
		if(col) {
			ordered.push(col)
		}
	})
	unorderedOptionColumns.forEach(col => {
		if(!ordered.find(f => f.id === col.id)) {
			ordered.push(col)
		}
	})
	return ordered
}

const dataTableHtmlTransformDateSearch = (input) => {
	const parts = input.split(' ');

	// Date part
	const dateParts = (parts[0] || '').split('.')

	const day = dateParts[0] || ''
	const month = dateParts[1] || ''
	const year = dateParts[2] || ''

	let result = ''

	if (year && year.length === 4) {
		result += year
	}

	if (month && month.length === 2) {
		result += (result ? '-' : '') + month
	}

	if (day) {
		result += (result ? '-' : '') + day
	}

	// Time part
	if (parts[1]) {
		result += ' ' + parts[1]
	}

	return result
};

export { orderDataTableColumns, dataTableHtmlTransformDateSearch };
